import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingData from '../MiniComponent/LoadingData'

const PAGE_SIZE = 5

const ClientTable = ({ data, loading }) => {
    let navigate = useNavigate()

    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [pageInput, setPageInput] = useState(1)

    // Filter by search
    const filtered = (data || []).filter(obj => {
        const q = search.toLowerCase()
        return (
            (obj.client_name || '').toLowerCase().includes(q) ||
            (obj.company_name || '').toLowerCase().includes(q) ||
            (obj.client_email || '').toLowerCase().includes(q) ||
            (obj.client_phone || '').toLowerCase().includes(q) ||
            (obj.client_id || '').toLowerCase().includes(q) ||
            (obj.gst_number || '').toLowerCase().includes(q)
        )
    })

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))

    // Reset to page 1 when search changes
    useEffect(() => {
        setCurrentPage(1)
        setPageInput(1)
    }, [search])

    useEffect(() => {
        setPageInput(currentPage)
    }, [currentPage])

    const paginated = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)

    const goToPage = (page) => {
        const p = Math.max(1, Math.min(page, totalPages))
        setCurrentPage(p)
        setPageInput(p)
    }

    return (
        <div className='px-2'>
            {/* Search bar */}
            <div className="flex justify-between items-center mb-2 gap-2 flex-wrap">
                <p className="text-sm text-gray-500 m-0">
                    Total: <strong>{filtered.length}</strong> client{filtered.length !== 1 ? 's' : ''}
                </p>
                <input
                    type="text"
                    placeholder="Search by name, company, email, phone, GST..."
                    className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none w-72 focus:ring-2 focus:ring-blue-400"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            {/* Table */}
            <main className="tablebg table-responsive my-2 rounded h-[55vh] overflow-y-scroll">
                <table className='w-full'>
                    <thead>
                        <tr className='sticky top-0'>
                            <th>SI No</th>
                            <th>Client ID</th>
                            <th>Client Name</th>
                            <th>Phone No</th>
                            <th>Email ID</th>
                            <th>Company Name</th>
                            <th>GST Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7">
                                    <LoadingData css="h-[20vh]" />
                                </td>
                            </tr>
                        ) : paginated.length > 0 ? (
                            paginated.map((obj, index) => (
                                <tr
                                    key={obj.id}
                                    onClick={() => navigate(`/client/${obj.id}`)}
                                    className='hover:bg-slate-100 cursor-pointer'
                                >
                                    <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                    <td>{obj.client_id || '—'}</td>
                                    <td>{obj.client_name || '—'}</td>
                                    <td>{obj.client_phone || '—'}</td>
                                    <td>{obj.client_email || '—'}</td>
                                    <td>{obj.company_name || '—'}</td>
                                    <td>{obj.gst_number || '—'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center py-8 italic text-gray-400">
                                    {search ? `No clients found for "${search}"` : 'No clients found.'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </main>

            {/* Pagination */}
            {filtered.length > PAGE_SIZE && (
                <div className="d-flex justify-content-between align-items-center mt-1 bg-white p-2 rounded shadow-sm">
                    <div className="text-sm">
                        Total: <strong>{filtered.length}</strong> | Page: <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-primary btn-sm rounded px-2"
                            disabled={currentPage === 1}
                            onClick={() => goToPage(currentPage - 1)}
                        >
                            Previous
                        </button>

                        <div className="small px-3 bg-primary text-white rounded py-1">
                            {currentPage} of {totalPages}
                        </div>

                        <button
                            className="btn btn-primary btn-sm"
                            disabled={currentPage === totalPages}
                            onClick={() => goToPage(currentPage + 1)}
                        >
                            Next
                        </button>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <span className="text-sm">Page</span>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            style={{ width: '55px' }}
                            min={1}
                            max={totalPages}
                            value={pageInput}
                            onChange={e => setPageInput(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    goToPage(Number(pageInput))
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ClientTable